<template>
  <div class="c-app role-theme-app" :class="{ 'c-dark-theme': $store.state.darkMode }">
    <TheHeader />
    <TheSidebar />

    <div
      class="c-wrapper"
      :class="{
        'sidebar-open': $store.state.sidebarShow && !$store.state.sidebarMinimize,
        'sidebar-minimized': $store.state.sidebarMinimize
      }"
    >
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <router-view></router-view>
          </CContainer>
        </main>
        <TheFooter />
      </div>
    </div>

    <RoleBottomNav role="technician" />

    <!-- Global Floating Report Action Button -->
    <FloatingReportFab />

    <CenterLoading />
    <DialogMessage />
    <SignIn />
  </div>
</template>

<script>
import TheSidebar from './TheSidebar'
import TheHeader from './TheHeader'
import TheFooter from '../TheFooter'
import RoleBottomNav from '@/components/common/RoleBottomNav.vue'
import FloatingReportFab from '@/components/common/FloatingReportFab.vue'
import { mapActions } from "vuex";

export default {
  name: 'TheContainer',
  components: {
    TheSidebar,
    TheHeader,
    TheFooter,
    RoleBottomNav,
    FloatingReportFab,
  },
  mounted() {
    document.body.classList.add('role-unified-theme');
    this.loadUserProfile();
  },
  beforeDestroy() {
    document.body.classList.remove('role-unified-theme');
  },
  methods: {
    ...mapActions("user", ["getProfile"]),
    async loadUserProfile() {
      try {
        await this.getProfile(); 
      } catch (err) {
        console.error("Load profile error:", err);
      }
    },
  },
};
</script>

<style scoped>
.c-wrapper {
  transition: margin-left 0.3s ease;
  margin-left: 0 !important;
}

.c-body {
  padding-top: 82px;
  min-height: 100vh;
}

@media (max-width: 768px) {
  .c-body {
    padding-top: 70px;
  }

  .c-main {
    padding-top: 10px;
  }
}

@media (min-width: 768px) {
  .c-main {
    width: 100%;
    padding: 18px 0 0;
  }

  .c-main > .container-fluid {
    width: 100%;
    max-width: none;
    padding-right: 18px;
    padding-left: 18px;
  }
}

/* 🔥🔥🔥 จุดที่แก้ไข: ใช้ Media Query บังคับเฉพาะหน้าจอใหญ่ (Desktop) 🔥🔥🔥 */
@media (min-width: 1201px) {
  /* เมื่อหน้าจอกว้างกว่า 992px (Desktop/Tablet แนวนอน) ถึงจะขยับ Margin */
  .sidebar-open {
    margin-left: 250px !important; /* ความกว้าง Sidebar */
  }
  
  .sidebar-minimized {
    margin-left: 70px !important;
  }
}
</style>
